import { blissZipServiceStatus, BLISS_ZIP_CUSTOMER_COPY } from '../../utils/blissServiceArea'
import { calculateBlissDeliveryFromZip } from '../../utils/blissDeliveryDistance'

export default function BlissZipFeedback({ zip, showPricing = true }: { zip: string; showPricing?: boolean }) {
  const status = blissZipServiceStatus(zip)
  const distance = status === 'full_service' ? calculateBlissDeliveryFromZip(zip, 1) : null
  return (
    <div className="bliss-zip-feedback" aria-live="polite">
      {status === 'full_service' && <p>{BLISS_ZIP_CUSTOMER_COPY.fullService}</p>}
      {status === 'design_consult_only' && (
        <p>
          Full-service delivery and installation are not available at this jobsite. You can still
          plan your room and explore design assistance.
        </p>
      )}
      {status === 'invalid' && zip.length === 5 && (
        <p role="alert">Enter a valid five-digit jobsite ZIP.</p>
      )}
      {showPricing && distance && (
        <details>
          <summary>Delivery estimate from Santa Rosa Beach, FL</summary>
          <p>
            Delivery planning estimate: $1.00–$1.50 per mile from 32459 (Santa Rosa Beach, FL).
            ZIP-based distance is approximately {Math.round(distance.distanceMiles)} miles, not a
            verified driving route. Your quote uses our current delivery charges; this range is
            guidance only.
          </p>
        </details>
      )}
    </div>
  )
}
